import React from 'react';
import { useSlideData } from '@context/slide-data';
import { SectionOne } from './SectionOne';
import { SectionTwo } from './SectionTwo';
import { SectionThree } from './SectionThree';

export const AdditionalInfoScript = () => {
    const { data, slideState } = useSlideData();
    const { selectedSection } = slideState;

    const sections = {
        1: <SectionOne />,
        2: <SectionTwo />,
        3: <SectionThree />
    };

    return sections[selectedSection[data.id]];
};

export default AdditionalInfoScript;
